import objectAssign from 'object-assign';

Object.assign = objectAssign;



// WEBPACK FOOTER //
// ./src/polyfill.js